export const SET_SUBSCRIPTIONS = "SET_SUBSCRIPTIONS";
export const SET_SUBSCRIPTION_LOADING = "SET_SUBSCRIPTION_LOADING";

export const SAGA_CATEGORY_SUBSCRIPTIONS_REQUESTED = "SAGA_CATEGORY_SUBSCRIPTIONS_REQUESTED";
export const SAGA_TOGGLE_SUBSCRIPTION = "SAGA_TOGGLE_SUBSCRIPTION";

export class Saga {
  static requestCategorySubscriptions() {
    return {
      type: SAGA_CATEGORY_SUBSCRIPTIONS_REQUESTED
    }
  };
  static requestToggleSubscription(categoryId){
    return {
      type: SAGA_TOGGLE_SUBSCRIPTION,
      categoryId
    }
  }

}

export class Generator {
  static setSubscriptionLoading(categoryId, loading) {
    return {
      type: SET_SUBSCRIPTION_LOADING,
      categoryId,
      loading
    }
  };
  static setSubscriptions(subscriptions) {
    return {
      type: SET_SUBSCRIPTIONS,
      subscriptions
    }
  };
}